import "swiper/css";
import Swiper from "swiper";
import { Navigation } from "swiper/modules";

class SliderPricing {
  constructor() {
    this.swipers = [];
    this.pricingSlider();
  }

  pricingSlider = () => {
    const slides = document.querySelectorAll(".swiper-pricing");

    slides.forEach((slider, index) => {
      slider.classList.add("swiper-pricing-" + index);

      const swiper = new Swiper(".swiper-pricing-" + index, {
        modules: [Navigation],
        autoHeight: true,
        slidesPerView: 1,
        spaceBetween: 24,
        loop: false,
        navigation: {
          nextEl: `.swiper-pricing-${index} .swiper-button-next`,
          prevEl: `.swiper-pricing-${index} .swiper-button-prev`,
        },
        breakpoints: {
          1000: {
            slidesPerView: 2,
          },
          1300: {
            slidesPerView: 3,
          },
          1450: {
            slidesPerView: 4,
          },
        },
      });

    });
  }
}

export default SliderPricing;
